import { render, staticRenderFns } from "./SensorsAndRelaysNaming.vue?vue&type=template&id=20116abf&scoped=true&"
import script from "./SensorsAndRelaysNaming.vue?vue&type=script&lang=js&"
export * from "./SensorsAndRelaysNaming.vue?vue&type=script&lang=js&"
import style0 from "./SensorsAndRelaysNaming.vue?vue&type=style&index=0&id=20116abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20116abf",
  null
  
)

export default component.exports